import { DataQueryParams } from 'common/src/query-params/DataQueryParams';
import { IPage, IProject } from 'common/src/types/interfaces';

import { API_BASE_PATHS } from 'portal/src/api/constants';
import formatQueryParams from 'portal/src/api/formatQueryParams';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from 'portal/src/api/requestTypes';

export const getProjects = async (
  params?: DataQueryParams,
): Promise<IPage<IProject>> =>
  await getRequest(API_BASE_PATHS.PROJECTS, formatQueryParams(params));

export const addProject = async (body: any) =>
  await postRequest(API_BASE_PATHS.PROJECTS, {}, body);

export const updateProject = async (id: string, body: any) =>
  await patchRequest(`${API_BASE_PATHS.PROJECTS}/${id}`, {}, body);

export const deleteProject = async (id: string): Promise<void> =>
  await deleteRequest(`${API_BASE_PATHS.PROJECTS}/${id}`, {});
